import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { GeographyService } from 'src/app/services/geography/geography.service';
import { Brewery } from 'src/app/classes/biermi';

declare var $: any;

@Component({
  selector: 'app-browse',
  templateUrl: './browse.component.html',
  styleUrls: ['./browse.component.scss']
})
export class BrowseComponent implements OnInit {

	loading;
	loadingStateBreweries: boolean;
	breweries: Brewery[];
	allBreweries: Brewery[];
	stateBreweries;
	filterState: string = 'ALL';

	activeStates = [];

	precannedMessages = [
		`Hey, I am a fan of your brewery and I was shopping on biermi and noticed that you are not on biermi yet. I love your beer but I would love it even more if it was listed: https://biermi.com/`,
		`Hey gang, I was just cruising biermi and didn’t see you guys on there. I’d love to see you guys listed on there so I can buy your beer. Thanks and hopefully see you soon! https://biermi.com/`,
		`I love what you’re doing with your beers! While I’ve been checking out other breweries on biermi because it’s easy, I wish I could grab your beer there, too. Are you guys considering joining? https://biermi.com/`,
		`Hey, I just wanna let you know that I really love your beer and I’d love even more to see it on biermi. Have you guys thought about selling through biermi? https://biermi.com/`,
		`Hey crew, huge fan of your beer. I was checking biermi though and I noticed you’re not listed there. I’d love to support you guys by buying some of your beer through biermi. Are you planning to join it? https://biermi.com/`,
		`Hey, have you considered joining biermi? I’ve been checking out a bunch of local breweries and noticed you weren’t listed. I’d love to be able to buy your beer there, too! https://biermi.com/`,
		`I’m a fan of your brewery and would really love to be able to buy your beer on biermi. Would you consider listing some beer there? https://biermi.com/`,
		`You make great beer but it’d be a lot easier for me to buy it if you were listed on biermi. Have you thought about joining? I’d definitely buy some beer from you there if I could! https://biermi.com/`,
		`I’m thirsty as heck for your beer right now but I couldn’t find it listed on biermi! Would you consider listing it there? I’m there buying beer on biermi already and would love to add your beer to my list as well! https://biermi.com/`
	];

	constructor(private api: ApiService, private geography: GeographyService) { }

	ngOnInit() {
		this.load();
	}

	load() {
		this.loading = true;
		this.api.getBreweriesLive().subscribe((breweries: Brewery[]) => {
			this.breweries = this.shuffle(breweries);
			this.allBreweries = JSON.parse(JSON.stringify(breweries));
			this.loading = false;
		});
	}

	getStates() {
		return this.geography.states;
	}

	getRandomBody() {
		return encodeURI(this.precannedMessages[Math.floor(Math.random() * this.precannedMessages.length)]);
	}

	filter(state?) {
		if(!this.allBreweries) {
			return;
		}
		if(state != 'ALL' && !this.active(state)) {
			return;
		}
		if(this.active(state) || state == 'ALL') {
			this.filterState = state;
		}
		if(this.filterState == 'ALL') {
			this.breweries = this.shuffle(this.allBreweries);
		} else {
			this.breweries = this.shuffle(this.allBreweries.filter(b => b.state == this.filterState));

			this.loadingStateBreweries = true;
			this.api.getNotLiveBreweriesByState(this.filterState).subscribe((stateBreweries: any) => {
				this.stateBreweries = stateBreweries;
				this.stateBreweries.forEach(b => b.mailtoLink = 'mailto:' + b.EmailAddress + '?subject=biermi&body=' + this.getRandomBody());
				this.loadingStateBreweries = false;
			});
		}
		$('html, body').animate({
			scrollTop: $(`.intro-section`).outerHeight(),
		}, 400);
	}

	active(state) {
		return true;
		// return this.geography.activeStates.indexOf(state) > -1;
	}

	shuffle(array) {
		var currentIndex = array.length, temporaryValue, randomIndex;
		while (0 !== currentIndex) {
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex -= 1;

			temporaryValue = array[currentIndex];
			array[currentIndex] = array[randomIndex];
			array[randomIndex] = temporaryValue;
		}

		return array;
	}
}